import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { RequestTokenService } from '../request-token.service';
import { DownloadArquivoSignature } from '../../app/shared/Signature/DownloadArquivoSignature';
import {
  ArquivosFeedbackSignature,
  CarregarArquivosRegistroFeedbackSignature
} from '../../app/pages/negocio/cliente/components/status-negocio/shared/models/signature/ArquivosFeedbackSignature';

const API_URL = `${environment.apiUrl}v6/Arquivo`;

@Injectable({
  providedIn: 'root'
})
export class ArquivoService {
 
  constructor(
    private http: HttpClient,
    private requestToken: RequestTokenService
  ) {  }

  private handleError(error: any): Observable<never> {
    console.error('API error:', error);
    return throwError(() => error);
  }

  public IncluirArquivoRegistroFeedback(signature: ArquivosFeedbackSignature): Observable<any> {
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true
    };

    return this.http.post<any>(`${API_URL}/IncluirArquivoRegistroFeedback`, signature, options).pipe(
      catchError(error => this.handleError(error))
    );
  }

  public CarregarArquivosRegistroFeedback(signature: CarregarArquivosRegistroFeedbackSignature): Observable<any> {
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true
    };

    return this.http.post<any>(`${API_URL}/CarregarArquivosRegistroFeedback`, signature, options).pipe(
      catchError(error => this.handleError(error))
    );
  }

  public DeletarArquivosRegistroFeedback(id: string): Observable<any> {
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true
    };

    return this.http.post<any>(`${API_URL}/DeletarArquivosRegistroFeedback/${id}`, null, options).pipe(
      catchError(error => this.handleError(error))
    );
  }

  public downloadExcel(signature: DownloadArquivoSignature): Observable<Blob> {
    var headers = this.requestToken.createAuthorizationHeader();
    headers.set('Content-Type', 'application/json');

    return this.http.post(`${API_URL}/DownloadExcel`, signature, {
      responseType: 'blob',
      headers: headers,
      withCredentials: true
    }).pipe(
      catchError(error => this.handleError(error))
    );
  }
} 